import React, { useState } from 'react';
import {useParams} from "react-router";
import {Helmet} from "react-helmet-async";

const LegalPage = () => {

    const params = useParams();

    const [activeTab, setActiveTab] = useState(params.document);

    //privacy, cookies, terms

    return (
        <>
            <Helmet>
                <title>{params.document} — Hlushman House</title>
                <meta name="title" content={"Правова інформація " + params.document} />
                <meta name="description" content="Правова інформація: правила використання сайтом, політика конфіденційності та політика cookies" />
                <meta property="og:title" content={params.document + " — Hlushman House"} />
                <meta property="og:description" content="Ознайомтеся з правилами використання сайту, політикою конфіденційності та умовами обробки персональних даних." />
                <meta property="og:image" content="https://hlushman.site/img/logo.jpg" />
                <meta property="og:url" content={"https:///hlushman.site/legal/" + params.document} />
            </Helmet>

            <div className="bg-stone-50 text-stone-800 min-h-screen font-sans">
                {params.document}
                {/* Header */}
                <section className="bg-stone-900 text-white py-16 px-6 text-center">
                    <div className="max-w-4xl mx-auto">
                        <span className="text-emerald-400 font-semibold tracking-widest uppercase text-sm">Юридична інформація</span>
                        <h1 className="text-3xl md:text-5xl font-serif font-bold mt-2 mb-4">Умови та Політики</h1>
                        <p className="text-stone-300 max-w-xl mx-auto font-light text-sm md:text-base">
                            Ознайомтеся з правилами користування сайтом, політикою обробки персональних даних та файлів cookie.
                        </p>
                    </div>
                </section>

                {/* Navigation Tabs */}
                <div className="sticky top-0 bg-white border-b border-stone-200 z-20 shadow-sm">
                    <div className="max-w-4xl mx-auto flex justify-center gap-2 md:gap-8 px-4 overflow-x-auto">
                        <button
                            onClick={() => setActiveTab('privacy-policy')}
                            className={`py-4 px-3 md:px-6 font-medium text-sm md:text-base border-b-2 whitespace-nowrap transition-colors ${
                                activeTab === 'privacy-policy'
                                    ? 'border-emerald-600 text-emerald-800 font-semibold'
                                    : 'border-transparent text-stone-500 hover:text-stone-900'
                            }`}
                        >
                            Політика конфіденційності
                        </button>
                        <button
                            onClick={() => setActiveTab('cookies-policy')}
                            className={`py-4 px-3 md:px-6 font-medium text-sm md:text-base border-b-2 whitespace-nowrap transition-colors ${
                                activeTab === 'cookies-policy'
                                    ? 'border-emerald-600 text-emerald-800 font-semibold'
                                    : 'border-transparent text-stone-500 hover:text-stone-900'
                            }`}
                        >
                            Політика Cookie
                        </button>
                        <button
                            onClick={() => setActiveTab('terms-of-service')}
                            className={`py-4 px-3 md:px-6 font-medium text-sm md:text-base border-b-2 whitespace-nowrap transition-colors ${
                                activeTab === 'terms-of-service'
                                    ? 'border-emerald-600 text-emerald-800 font-semibold'
                                    : 'border-transparent text-stone-500 hover:text-stone-900'
                            }`}
                        >
                            Правила користування
                        </button>
                    </div>
                </div>

                {/* Content Area */}
                <main className="py-12 px-6 max-w-4xl mx-auto bg-white my-8 rounded-2xl border border-stone-200 shadow-sm">

                    {/* 1. Privacy Policy */}
                    {activeTab === 'privacy-policy' && (
                        <article className="space-y-6 text-stone-700 leading-relaxed">
                            <h2 className="text-2xl font-serif font-bold text-stone-900">Політика конфіденційності</h2>
                            <p className="text-sm text-stone-500">Останнє оновлення: 2026 рік</p>

                            <p>
                                Hlushman House поважає вашу приватність та зобов'язується захищати ваші персональні дані відповідно до Закону України «Про захист персональних даних».
                            </p>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">1. Які дані ми збираємо</h3>
                            <ul className="list-disc pl-5 space-y-2">
                                <li>Ім'я та прізвище</li>
                                <li>Номер телефону, email або контактні дані у месенджерах</li>
                                <li>Бажані дати та деталі бронювання</li>
                                <li>Технічні дані (IP-адреса, тип пристрою, браузер)</li>
                            </ul>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">2. Мета обробки даних</h3>
                            <p>
                                Ми використовуємо ваші дані виключно для підтвердження та організації бронювання, зворотного зв'язку та покращення якості наших послуг.
                            </p>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">3. Передача даних третім особам</h3>
                            <p>
                                Ваші дані не передаються третім особам, за винятком випадків, передбачених чинним законодавством України.
                            </p>
                        </article>
                    )}

                    {/* 2. Cookie Policy */}
                    {activeTab === 'cookies-policy' && (
                        <article className="space-y-6 text-stone-700 leading-relaxed">
                            <h2 className="text-2xl font-serif font-bold text-stone-900">Використання файлів Cookie</h2>
                            <p className="text-sm text-stone-500">Останнє оновлення: 2026 рік</p>

                            <p>
                                Наш сайт використовує файли cookie для забезпечення зручної навігації, збереження ваших налаштувань та збору аналітики.
                            </p>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">Типи cookie, які ми використовуємо</h3>
                            <div className="space-y-3">
                                <div className="p-4 bg-stone-50 rounded-xl border border-stone-200">
                                    <span className="font-semibold text-stone-900">Обов’язкові cookie:</span> Необхідні для коректної роботи сайту та основних функцій.
                                </div>
                                <div className="p-4 bg-stone-50 rounded-xl border border-stone-200">
                                    <span className="font-semibold text-stone-900">Аналітичні cookie:</span> Допомагають нам зрозуміти, як відвідувачі взаємодіють із сайтом (наприклад, Google Analytics).
                                </div>
                            </div>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">Управління cookie</h3>
                            <p>
                                Ви можете відключити збереження файлів cookie у налаштуваннях вашого веб-браузера в будь-який момент.
                            </p>
                        </article>
                    )}

                    {/* 3. Terms of Use */}
                    {activeTab === 'terms-of-service' && (
                        <article className="space-y-6 text-stone-700 leading-relaxed">
                            <h2 className="text-2xl font-serif font-bold text-stone-900">Правила користування та проживання</h2>
                            <p className="text-sm text-stone-500">Останнє оновлення: 2026 рік</p>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">1. Бронювання та оплата</h3>
                            <p>
                                Бронювання вважається підтвердженим після внесення передплати. Повний розрахунок здійснюється під час заїзду.
                            </p>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">2. Правила проживання в Hlushman House</h3>
                            <ul className="list-disc pl-5 space-y-2">
                                <li><strong>Заїзд / Виїзд:</strong> Заїзд після 15:00, виїзд до 11:00 (інший час узгоджується індивідуально).</li>
                                <li><strong>Куріння:</strong> Куріння в приміщенні будинку суворо заборонено.</li>
                                <li><strong>Відпочинок із тваринами:</strong> Дозволений за попереднім узгодженням (Pet-Friendly).</li>
                                <li><strong>Майно:</strong> Гості несуть матеріальну відповідальність за збереження майна комплексу.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-stone-900 mt-4">3. Скасування бронювання</h3>
                            <p>
                                Умови скасування передплати залежать от обраного тарифу та термінів повідомлення про скасування.
                            </p>
                        </article>
                    )}

                </main>

            </div>
        </>
    );
};

export default LegalPage;